<template>
  <div>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs6>
          <v-btn flat to="/commercial" exact class="ma-0">  
            <v-icon color="grey lighten-1" class="mr-3">fas fa-angle-left</v-icon>
            <div class="headline">Neuf</div>
          </v-btn>
        </v-flex>
        <v-flex xs6 class="test-xs-right">
          <agences-list v-model="agence"></agences-list>
        </v-flex>
        <v-flex xs12 sm6 lg4>
          <v-card>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex xs8>
                  <div class="headline">{{ indicateurNeuf(this.agence, 'resasRealises') }} Reservations</div>
                  <div>Objectif à date : {{ indicateurNeuf(this.agence, 'resasObjectifs') }}</div>
                  <div>Objectif annuel : {{ indicateurNeuf(this.agence, 'resasObjectifs', 12) }}</div>
                </v-flex>
                <v-flex xs4 class="text-xs-center">
                  <progress-chart :data="indicateurNeuf(this.agence, 'resasRealises')/indicateurNeuf(this.agence, 'resasObjectifs')" :width="74" :height="74"></progress-chart>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
          <v-card class="mt-2">
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs12>
                  <line-chart :data="chartData2"></line-chart>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 lg4>
          <v-card>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex xs8>
                  <div class="headline">{{ indicateurNeuf(this.agence, 'actesRealises') }} Actes</div>
                  <div>Objectif à date : {{ indicateurNeuf(this.agence, 'actesObjectifs') }}</div>
                  <div>Objectif annuel : {{ indicateurNeuf(this.agence, 'actesObjectifs', 12) }}</div>
                </v-flex>
                <v-flex xs4 class="text-xs-center">
                  <progress-chart :data="indicateurNeuf(this.agence, 'actesRealises')/indicateurNeuf(this.agence, 'actesObjectifs')" :width="74" :height="74"></progress-chart>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
          <v-card class="mt-2">
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs12>
                  <line-chart :data="chartData"></line-chart>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
        <v-flex xs6 lg2>
          <v-card>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12 class="text-xs-center">
                  <div class="headline">{{ indicateurNeuf(null, 'tauxAnnul')*100 }} %</div>
                  <div>Taux d'annulation</div>
                  <div class="caption italic">(toutes agences)</div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
        <v-flex xs6 lg2>
          <v-card>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12 class="text-xs-center">
                  <div class="headline">{{ indicateurNeuf(null, 'nbContact') }}</div>
                  <div>Contacts</div>
                  <div class="caption italic">(toutes agences)</div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import LineChart from '@/components/charts/LineChart.js'
import ProgressChart from '@/components/charts/ProgressChart'
import { mapGetters } from 'vuex'

export default {
  name: 'Neuf',
  components: {
    LineChart, ProgressChart
  },
  data() {
    return {
      agence : 'Toutes',
    }
  },
  computed: {
    ...mapGetters(['indicateurNeuf', 'serieNeuf']),
    chartData() {
      return {
        labels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        datasets: [
          {
            label: 'Réalisé',
            backgroundColor: '#E53935',
            data: this.serieNeuf(this.agence, 'actesRealises')
          },
          {
            label: 'Objectif',
            backgroundColor: '#FFCC80',
            data: this.serieNeuf(this.agence, 'actesObjectifs')
          },
        ]
      }
    },
    chartData2() {
      return {
        labels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        datasets: [
          {
            label: 'Réalisé',
            backgroundColor: '#E53935',
            data: this.serieNeuf(this.agence, 'resasRealises')
          },
          {
            label: 'Objectif',
            backgroundColor: '#FFCC80',
            data: this.serieNeuf(this.agence, 'resasObjectifs')
          },
        ]
      }
    } 
  }
}
</script>

<style scoped>

</style>
